import { authFetch } from "./util";
import { PublicUser, User } from "../models";

export async function getUser(userID: string): Promise<PublicUser | User> {
  return authFetch("GET", `/api/users/${userID}`);
}
